import { getValue } from "@utils/lodash";
import "../Comments/comments-section.scss";
import { convertCurrentDateWithTime } from "@_common/date-helpers";
import { getFirstLetter } from "@_common/format-text";
import EditGreySvgComponent from "../../../../assets/svg-components/edit";
import DeleteSvgComponent from "../../../../assets/svg-components/delete";
import ReactTooltip from "react-tooltip";

export default function OldComments(props: any) {
  const oldCommentsArray = [
    {
      imageUrl: "/images/support/person-icon.png",
      name: " Rajendra GS",
    },
    {
      name: "Anthony Joseph",
    },
    {
      imageUrl: "/images/support/person-icon.png",
      name: " Rajendra GS",
    },
    {
      name: "Anthony Joseph",
    },
    {
      imageUrl: "/images/support/person-icon.png",
      name: " Rajendra GS",
    },
  ];
  let user: any = JSON.parse(getValue(localStorage, `user`, ""));

  return (
    <section className="add-comments-wrapper">
      {getValue(props, `data`, []).map((commentObj: any, index: number) => {
        return (
          <div className="my-4" key={index}>
            <div className="d-flex align-items-start w-100">
              {commentObj.imageUrl ? (
                <label className="add-comments-wrapper__img-label">
                  <img
                    src="/images/support/person-icon.png"
                    className="img-fluid"
                    height={48}
                    width={48}
                  />
                </label>
              ) : (
                <div className="add-comments-wrapper__label-container">
                  <label className="add-comments-wrapper__label d-flex">
                    <h6>
                      {getFirstLetter(
                        getValue(commentObj, `created_by.first_name`, "")
                      )}
                    </h6>
                  </label>
                </div>
              )}
              <div className="comment-bubble-main w-100">
                <div className="comment-bubble-wrap">
                  <div className="add-comments-wrapper__header-list-wrapper">
                    <ReactTooltip
                      id="editComment"
                      effect="solid"
                      place="bottom"
                    >
                      Edit
                    </ReactTooltip>

                    <ReactTooltip
                      id="deleteComment"
                      effect="solid"
                      place="bottom"
                    >
                      Delete
                    </ReactTooltip>
                    <ul className="add-comments-wrapper__header-list d-inline-flex align-items-center w-100">
                      <li className="add-comments-wrapper__header-list-items comment-name-wrapper">
                        {getValue(commentObj, `created_by.first_name`, "")}{" "}
                        {getValue(commentObj, `created_by.last_name`, "")}
                      </li>
                      {getValue(user, `id`, "") ===
                        getValue(commentObj, `created_by.id`, "") && (
                        <>
                          {getValue(props, `permissions`, []).includes(
                            "update"
                          ) && (
                            <li
                              className="add-comments-wrapper__header-list-items cursor-pointer edit-float-icon"
                              onClick={() =>
                                props.handleEditComments(
                                  getValue(commentObj, `id`, ""),
                                  getValue(commentObj, `comments`, "")
                                )
                              }
                              data-tip
                              data-for="editComment"
                            >
                              {/* Edit */}
                              <EditGreySvgComponent size={18} />
                            </li>
                          )}
                          {getValue(props, `permissions`, []).includes(
                            "update"
                          ) && (
                            <li
                              className="add-comments-wrapper__header-list-items cursor-pointer delete-float-icon"
                              onClick={() =>
                                props.handleDelete(
                                  getValue(commentObj, `id`, ""),
                                  getValue(commentObj, `comments`, "")
                                )
                              }
                              data-tip
                              data-for="deleteComment"
                            >
                              {/* Delete */}
                              <DeleteSvgComponent size={18} color={"#F75751"} />
                            </li>
                          )}
                        </>
                      )}
                    </ul>
                    <ul className="add-comments-wrapper__header-description d-inline-flex align-items-center d-none">
                      <li className="add-comments-wrapper__header-description-list">
                        Posted On -{" "}
                        {convertCurrentDateWithTime(
                          getValue(commentObj, `created_at`, "")
                        )}
                      </li>
                      {/* <li className="add-comments-wrapper__header-description-list">
                    AVP Admin
                  </li>
                  <li className="add-comments-wrapper__header-description-list">
                    Accenture - Bangalore
                  </li> */}
                    </ul>
                  </div>
                  <p className="add-comments-wrapper__header-description-text">
                    {getValue(commentObj, `comments`, "")}
                  </p>
                  {/* <div className="time-stamp-wrap text-right">
                  {convertCurrentDateWithTime(
                    getValue(commentObj, `created_at`, "")
                  )}
                </div> */}
                </div>
                <div className="time-stamp-wrap text-right">
                  {convertCurrentDateWithTime(
                    getValue(commentObj, `created_at`, "")
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </section>
  );
}
